module.exports = __webpack_public_path__ + "img/User-Active-Dark.61ce849.svg";